import { getChainName } from '@revoke.cash/core/chains';
import ChainLogo from 'components/common/ChainLogo';

interface Props {
  chainId: number;
}

const HistoryChainCell = ({ chainId }: Props) => {
  return (
    <div className="flex items-center gap-1.5 py-3.25 w-fit">
      <ChainLogo chainId={chainId} size={24} />
      <span className="whitespace-nowrap">{getChainName(chainId)}</span>
    </div>
  );
};

export default HistoryChainCell;
